module.exports = __webpack_public_path__ + "static/media/avatar.410d1c86.png";